module.exports = __webpack_public_path__ + "static/subset-UniNeueHeavy-0f75e73aae5de5f753ff231dacecfd6e.woff";